import React, { useMemo, useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { AdminLayout } from '../adminLayout';
import { IntlMessages } from '../../../helper/langHelper';
import { getPdfs } from '../../../services/admin/pdfs';
import { UsersContainer, UsersHeader, LoaderWrapper, IconButton } from '../users/Users.styles';

import { Table } from '../../../components/uielements/table';
import EditPdfModal from './modals/EditPdfModal';
import { PrimaryButton } from '../users/modals/UserPromoteModal.styles';

const Pdfs = () => {
  const [page, setPage] = useState(0);
  const [perPage] = useState(10);
  const [editPdfData, setEditPdfData] = useState(null);
  const [addPdfData, setAddPdfData] = useState(false);

  const { data, isLoading, isError } = useQuery({
    queryKey: ['adminPdfs', page, perPage],
    queryFn: () => getPdfs(page, perPage),
  });

  const tableData = data?.data ?? [];
  const total = data?.total ?? 0;

  const columns = useMemo(
    () => [
      {
        Header: <IntlMessages id="table.col.title" defaultMessage="Title" />,
        accessor: 'pdfName',
        width: '50%',
      },
      {
        Header: <IntlMessages id="table.col.id" defaultMessage="PDF ID" />,
        accessor: '_id',
        width: '30%',
      },
      {
        Header: <IntlMessages id="table.col.actions" defaultMessage="Actions" />,
        accessor: 'actions',
        isAction: true,
        width: '20%',
      },
    ],
    []
  );

  const actionList = [
    (data) => (
      <IconButton onClick={() => setEditPdfData(data)} variant="promote">
        <span style={{ fontSize: '13px', padding: '0 6px' }}>Edit</span>
      </IconButton>
    ),
  ];

  if (isLoading) {
    return (
      <AdminLayout pageTitle="PDFs" activeTab="pdfs">
        <LoaderWrapper>Loading...</LoaderWrapper>
      </AdminLayout>
    );
  }

  if (isError) {
    return (
      <AdminLayout pageTitle="PDFs" activeTab="pdfs">
        <LoaderWrapper>Oops! Error Encountered</LoaderWrapper>
      </AdminLayout>
    );
  }

  return (
    <AdminLayout activeTab="pdfs">
      <UsersContainer>
        <UsersHeader>
          <IntlMessages id="nav.pdfs" defaultMessage="PDFs" />
          <PrimaryButton onClick={() => setAddPdfData(true)}>Add PDF</PrimaryButton>
        </UsersHeader>

        <Table
          data={tableData}
          columns={columns}
          hasFooter={true}
          actions={actionList}
          page={page}
          pageSize={perPage}
          prevPage={() => setPage((p) => Math.max(0, p - 1))}
          nextPage={() => setPage((p) => p + 1)}
          total={total}
        />

        {editPdfData && (
          <EditPdfModal
            onClose={() => setEditPdfData(null)}
            isEdit={true}
            pdfId={editPdfData._id}
            initialTitle={editPdfData.pdfName}
          />
        )}
        {addPdfData && (
          <EditPdfModal onClose={() => setAddPdfData(false)} isEdit={false} pdfId={null} />
        )}
      </UsersContainer>
    </AdminLayout>
  );
};

export default Pdfs;
